<script lang="ts">
export default {
  name: 'KkValidationError',
}
</script>

<script lang="ts" setup>
export interface Props {
  text?: string
}

const props = defineProps<Props>()
</script>

<template>
  <p v-if="!!props.text" role="alert" class="validationError">{{ props.text }}</p>
</template>

<style lang="scss" scoped>
@import "../../../../../stylesheets/biz_spa/foundation/_var.scss";
.validationError {
  color: $color-accent-primary;
  font-size: 12px;
  white-space: pre-line;
}
</style>
